import axios from 'axios'
import store from '@/store'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import * as hdf5 from 'jsfive'
import { wrap, transfer } from 'comlink'
import 'worker-loader!./api_worker.worker.js' // NOTE: do not remove import
import { getEnvVar, getApiWorkerURL } from '@/utils/envUtils'

let cache = {}

const worker = new Worker(getApiWorkerURL());
const apiWorker = wrap(worker)

let Api = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})
let setHeaderToken = () => {
  if (localStorage.getItem('elem-session-token'))
    Api.defaults.headers.Authorization = 'Bearer ' + localStorage.getItem('elem-session-token')
}

setHeaderToken()

function cacheTrap(url, fetch) {
  if (!cache[url]) {
    if (fetch)
      cache[url] = fetch(url).then(result => {
        Object.freeze(result)
        return result
      })
    else cache[url] = Api.get(url)
  }
  return cache[url]
}

function get_redirected_url(url) {
  let token = localStorage.getItem('elem-session-token')
  return apiWorker.get_redirected_url(url, token)
}

// function getWithoutToken (url){
//   const xhttp = new XMLHttpRequest();
//   xhttp.withCredentials = false
//   xhttp.open('GET',url)
//   xhttp.send()
//   return new Promise((resolve)=>{
//     xhttp.onreadystatechange = function () {
//       if (this.readyState === 4 && this.status === 200){
//         resolve(this.responseText)
//       }
//     }
//   })
// }
function getWithOrWithoutToken(url, withToken = true, cb) {
  const xhttp = new XMLHttpRequest()
  const orig_url = url
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4 && this.status !== 200 && this.responseURL !== orig_url) {
      console.log(`reattempting auth-less redirect ${orig_url} -> ${this.responseURL}`)
      getWithOrWithoutToken(this.responseURL, false, cb)
    }
    if (this.readyState === 4 && this.status === 200) {
      // console.log(`successfully fetched: ${this.responseText}`)
      cb(JSON.parse(this.responseText))
    }
  }
  xhttp.withCredentials = false
  // smart_auth_get(xhttp, url, token);
  xhttp.open('GET', url)
  if (withToken)
    xhttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('elem-session-token'))
  xhttp.send()
}
function extractIds(params) {
  return {
    projectId: params.project.id,
    trialId: params.trial.id,
    templateId: params.subject.subject.templateId,
    subjectId: params.subject.subject.id
  }
}
export default {
  // a medias entre en "new" y el "old" ....

  // get3DSegments () {
  //   let url = 'static_data/case/model/ahapoints.json'
  //   return cacheTrap(url, url => {
  //     return Api.get(url).then(res => {
  //       return res.data
  //     })
  //   })
  // },
  get3dBundle(params, statusCallback) {
    let url

    if (params.subject) {
      let { projectId, trialId, templateId } = extractIds(params)
      url =
        getEnvVar('VUE_APP_API_URL') +
        `/project/${projectId}/trial/${trialId}/subject/${templateId}/output/mesh`
    } else {
      url = getEnvVar('VUE_APP_LOCAL_DATA_URL') + `/mesh/bv_model`
    }
    return cacheTrap(url, () => {
      return get_redirected_url(url).then(res => {
        // let modelUrl = res.mesh.modelUrls[0]
        let variablesUrl = res.mesh.dataUrl
        // let gltfUrl = url
        let promises = []
        promises.push(
          cacheTrap(variablesUrl, () => {
            return fetch(variablesUrl).then(res => {
              console.log('recevied variables')
              return res.arrayBuffer()
            })
          })
        )
        promises.push(
          new Promise(resolve => {
            var loader = new GLTFLoader()

            console.log('loading gltf')
            loader.parse(JSON.stringify(res.mesh.gltf), url, gltf => {
              console.log('gltf parsed?')
              let mesh = gltf.scene.children[0].children[1]
              //NO DEBERIA
              // mesh.geometry.center().rotateX(Math.PI).rotateZ(Math.PI/2)
              resolve(mesh)
            })
          })
        )

        /*// DONDE ESTAN LOS NUEVOS AHA POINTS?!
        let AHAurl = 'static_data/case/model/NEW/ahapoints.json'
        promises.push(cacheTrap(AHAurl, AHAurl => {
          return Api.get(AHAurl).then(res => {
            return res.data
          })
        }))
       */
        statusCallback('Loading 3D model')
        return Promise.all(promises).then(responses => {
          console.log('responses', responses)
          statusCallback('Extracting 3D model')
          return apiWorker
            .process_variables_buffer(responses[0])
            .then(unpackedData => {
              console.log('Extracted 3D model')
              return {
                model: responses[1],
                ...unpackedData,
              }
            })
            .catch(err => {
              statusCallback('Error processing 3D model')
              console.log(`error parsing data in 3D model ${err}`)
              return false
            })
        })
      })
    })
  },

  /*async process_variables_buffer (buffer) {
    debugger
    let bf = await apiWorker.process_variables_buffer(buffer)
    
    var f = new hdf5.File(buffer, 'surf_vars');
    // We assume the HDF5 alwayas has "Displacement", "Atlas" and value variables

    let datasets = f.keys
    const fixedDatasetKeys = ['Displacement', 'Atlas']
    let valuesDatasetKeys = f.keys.filter(e => !fixedDatasetKeys.includes(e))

    let timesSteps = valuesDatasetKeys.length > 0 ? f.get(valuesDatasetKeys[0]).get('time').shape[0] : []
    let vertexSteps = valuesDatasetKeys.length > 0 ? f.get(valuesDatasetKeys[0]).get('values').shape[1] : []

    //let tStart = window.performance.now()
    let dispVals = datasets.includes('Displacement') ? f.get('Displacement').get('values').value : false
    let atlasVals = datasets.includes('Atlas') ? f.get('Atlas').get('mesh_atlas').value : []

    let dynamicValues = valuesDatasetKeys.map(key => {
      return {
        key: key,
        values: f.get(key).get('values').value
      }
    })
    /*let CaVals = f.get('Ca').get('values').value
    let KVals = f.get('Ca').get('values').value
    let VVals = f.get('V').get('values').value*/
  /*let variables = [...Array(timesSteps).keys()].map(timeIndex => {
      return {
        t: +timeIndex * 0.025,
        values:[...Array(vertexSteps).keys()].map((vertexIndex) => {
          return {
            // NOT GOOD - NEED TO CHECK INDEX WITH NEW DATA (Time should not be mixed in)
            ...dynamicValues.reduce((acc,curr)=> 
              (acc[curr.key] = curr.values[(timeIndex * vertexSteps) + (vertexIndex)] ,acc),{}
            ),
            DISPL_0: dispVals ? dispVals[(timeIndex * vertexSteps * 3) + (vertexIndex) * 3 + 0] : 0,
            DISPL_1: dispVals ? dispVals[(timeIndex * vertexSteps * 3) + (vertexIndex) * 3 + 1] : 0,
            DISPL_2: dispVals ? dispVals[(timeIndex * vertexSteps *3) + (vertexIndex) * 3 + 2]: 0
          }
        })
      }
    })*/
  /*
    let workerData = {
      dynamicValues: dynamicValues,
      timesSteps: timesSteps,
      vertexSteps: vertexSteps,
      dispVals: dispVals
    }
    var string = JSON.stringify(workerData);
    var uint8_array = new TextEncoder("utf-8").encode(string);
    var array_buffer = uint8_array.buffer;
    let variables = await apiWorker.extract_model_vars(array_buffer, [array_buffer])
    // let tStop = window.performance.now()
    // console.log(`Execution time: ${tStop - tStart} ms`);
    // console.log("SURF HDF5")
    // console.log(variables)
    return {
      variables: variables,
      segmentDict: {AHA: atlasVals},
      varKeys: valuesDatasetKeys
    }
  },
  */
  // get3DSegments_NEW() {
  //   let url = 'static_data/case/model/NEW/ahapoints.json'
  //   return cacheTrap(url, url => {
  //     return Api.get(url).then(res => {
  //       return res.data
  //     })
  //   })
  // },
  getSegments(params) {
    let { projectId, trialId, templateId } = extractIds(params)
    // let url = 'static_data/case/segments/segments.json'
    // return cacheTrap(url, url => {
    //   return Api.get(url).then(res => {
    //     return res.data
    //   })
    // })
    // let url = getEnvVar('VUE_APP_API_URL')+`/project/10/trial/9/subject/2/output/segments`
    // return cacheTrap(url, url => {
    //   return Api.get(url).then(res => {
    //     return res.data
    //   })
    // })
    let url =
      getEnvVar('VUE_APP_API_URL') +
      `/project/${projectId}/trial/${trialId}/subject/${templateId}/output/segments`
    return cacheTrap(url, () => {
      return get_redirected_url(url).then(res => {
        return res.namedxyseries.map(s => ({ segmentData: s, segmentId: s.id }))
      })
    })
  },
  getLines(params) {
    // let url = 'static_data/case/lines/loops.json'
    // return cacheTrap(url, url => {
    //   return Api.get(url).then(res => {
    //     return res.data
    //   })
    // })
    let { projectId, trialId, templateId } = extractIds(params)
    let url =
      getEnvVar('VUE_APP_API_URL') +
      `/project/${projectId}/trial/${trialId}/subject/${templateId}/output/loops`
    return cacheTrap(url, () => {
      return get_redirected_url(url).then(res => {
        return res.namedxyseries
      })
    })
  },
  getEcg(params) {
    let { projectId, trialId, templateId } = extractIds(params)

    // let url = 'static_data/case/ecg/ecg.json'
    // return cacheTrap(url, url => {
    //   return Api.get(url).then(res => {
    //     return res.data.ECG_HQ.Table.map((row)=>{
    //       let rowObj = {}
    //       row.forEach((col,i)=>{
    //         rowObj[res.data.ECG_HQ.Header[i]] = row[i]
    //       })
    //       return rowObj
    //     })
    //   })
    // })
    // let url = getEnvVar('VUE_APP_API_URL')+`/project/10/trial/9/subject/2/output/ecg`
    // return cacheTrap(url, url => {
    //   return Api.get(url).then(res => {
    //     return res.data.ECG_HQ.Table.map((row)=>{
    //       let rowObj = {}
    //       row.forEach((col,i)=>{
    //         rowObj[res.data.ECG_HQ.Header[i]] = row[i]
    //       })
    //       return rowObj
    //     })
    //   })
    // })
    //let url = getEnvVar('VUE_APP_API_URL') + `/project/${projectId}/trial/${trialId}/subject/${templateId}/output/ecg`
    let url = getEnvVar('VUE_APP_API_URL') + `/outputs/${projectId}/${trialId}/${templateId}/ecg/`
    return cacheTrap(url, () => {
      return get_redirected_url(url).then(res => {
        return res.xyseries[0].rows.map(row => {
          let rowObj = {}

          //TODO: sometimes is 'header', other is 'headers'- need consistency on server side!
          let headerKey = 'header' in res.xyseries[0] ? 'header' : 'headers'

          row.forEach((col, i) => {
            rowObj[res.xyseries[0][headerKey][i]] = row[i]
          })
          return rowObj
        })
      }, error => store.dispatch('setError', error))
    })
  },
  // no es realmente un dataModel, pero tambien queremos CACHEARLO y FREZZEARLO !!!
  // get3dModel () {
  //   let url = 'static_data/case/model/mesh.gltf'
  //   return cacheTrap(url, url => {
  //     var loader = new GLTFLoader()
  //     return new Promise(resolve => {
  //       loader.load(url, gltf => {
  //         let mesh = gltf.scene.children[0].children[0]
  //         //NO DEBERIA
  //         mesh.geometry //.center()//.rotateX(Math.PI).rotateZ(Math.PI/2)
  //         resolve(mesh)
  //       })
  //     })
  //   })
  // },
  // get3dModel_NEW () {
  //   let url = 'static_data/case/model/NEW/mesh.gltf'
  //   return cacheTrap(url, url => {
  //     var loader = new GLTFLoader()
  //     return new Promise(resolve => {
  //       loader.load(url, gltf => {
  //         let mesh = gltf.scene.children[0].children[1]
  //         //NO DEBERIA
  //         // mesh.geometry.center().rotateX(Math.PI).rotateZ(Math.PI/2)
  //         resolve(mesh)
  //       })
  //     })
  //   })
  // },

  // get3DVariables (src) {
  //   let url = `static_data/case/model/${src}`
  //   return cacheTrap(url, url => {
  //     return Api.get(url).then(res => {
  //       let variables = res.data.map(timeSlice => {
  //         return {
  //           t: +timeSlice['Time'],
  //           values: timeSlice.DISPL.map((d, i) => {
  //             return {
  //               Ca: +timeSlice['INTRA'][i][0],
  //               DISPL_0: +timeSlice['DISPL'][i][0],
  //               DISPL_1: +timeSlice['DISPL'][i][1],
  //               DISPL_2: +timeSlice['DISPL'][i][2]
  //             }
  //           })
  //         }
  //       })
  //       return variables
  //     })
  //   })
  // },
  // get3DVariables_NEW(src) {
  //   let url = `static_data/case/model/NEW/${src}`
  //   return cacheTrap(url, url => {
  //     return Api.get(url).then(res => {
  //       let variables = res.data.map(timeSlice => {
  //         return {
  //           t: +timeSlice['Time'],
  //           values: timeSlice.Displacement.map((d, i) => {
  //             return {
  //               Ca: +timeSlice['Ca'][i],
  //               K: +timeSlice['K'][i],
  //               'V(mV)': +timeSlice['V(mV)'][i],
  //               DISPL_0: +timeSlice['Displacement'][i][0],
  //               DISPL_1: +timeSlice['Displacement'][i][1],
  //               DISPL_2: +timeSlice['Displacement'][i][2]
  //             }
  //           })
  //         }
  //       })
  //       console.log("SURF JSON")
  //       console.log(variables)
  //       return variables
  //     })
  //   })
  // },
  // get3DVariablesHDF5(src) {
  //   let url = `static_data/case/model/NEW/hdf5/${src}`
  //   // let url =  getEnvVar('VUE_APP_API_URL')+`/project/${10}/trial/${7}/subject/${7}/output/mesh`
  //   return cacheTrap(url, url => {
  //     // axios no funciona bien, de momento ok con fetch
  //     return get_redirected_url(url).then(response => {
  //       return response.arrayBuffer()
  //     })
  //     .then(function(buffer) {
  //       var f = new hdf5.File(buffer, 'surf_vars');
  //       console.log(f)
  //       let datasets = f.keys
  //       let timesSteps = f.get(datasets[0]).shape[0]
  //       let vertexSteps = f.get(datasets[0]).shape[1]
  //       let tStart = window.performance.now()

  //       let CaVals = f.get('calcium').value
  //       let KVals = f.get('potassium').value
  //       let VVals = f.get('voltage').value
  //       let dispVals = f.get('displacement').value
  //       let variables = [...Array(timesSteps).keys()].map(timeIndex => {
  //         return {
  //           t: +timeIndex * 0.025,
  //           values:[...Array(vertexSteps-1).keys()].map((vertexIndex) => {
  //             return {
  //               // NOT GOOD - NEED TO CHECK INDEX WITH NEW DATA (Time should not be mixed in)
  //               Ca: CaVals[(timeIndex * vertexSteps) + (vertexIndex + 1)],
  //               K: KVals[(timeIndex * vertexSteps) + (vertexIndex + 1)],
  //               'V(mV)': VVals[(timeIndex * vertexSteps) + (vertexIndex + 1)],
  //               DISPL_0: dispVals[(timeIndex * vertexSteps * 3) + (vertexIndex +1) * 3 + 0],
  //               DISPL_1: dispVals[(timeIndex * vertexSteps * 3) + (vertexIndex +1) * 3 + 1],
  //               DISPL_2: dispVals[(timeIndex * vertexSteps *3) + (vertexIndex +1) * 3 + 2]
  //             }
  //           })
  //         }
  //       })
  //       let tStop = window.performance.now()
  //       console.log(`Execution time: ${tStop - tStart} ms`);
  //       console.log("SURF HDF5")
  //       console.log(variables)
  //       return variables
  //     });
  //   })
  // },
  getPlanesByIds(projectId, trialId, templateId) {
    let url =
      getEnvVar('VUE_APP_API_URL') +
      `/project/${projectId}/trial/${trialId}/subject/${templateId}/output/slices`
    return cacheTrap(url, () => {
      return get_redirected_url(url).then(res => {
        return res.slices
      })
    })
  },
  getPlanes(params) {
    let { projectId, trialId, templateId } = extractIds(params)
    return this.getPlanesByIds(projectId, trialId, templateId)
    // let url = 'static_data/case/videos/OLD/planes.csv'
    // let url = getEnvVar('VUE_APP_API_URL')+`/project/10/trial/9/subject/2/output/slices`
    // return cacheTrap(url, url => {
    //   return Api.get(url).then(res => {
    //     // let json = Papa.parse(res.data, { header: true }).data
    //     return res.data.slices
    //   })
    // })
    // let url = getEnvVar('VUE_APP_API_URL')+`/project/${projectId}/trial/${trialId}/subject/${templateId}/output/slices`
    // return cacheTrap(url, ()=> {
    //   return get_redirected_url(url).then(res => {
    //     return res.slices
    //   })
    // })
  },
  // getPlanes_NEW () {
  //   let reqs = ['la','sa'].map((dir)=>this.getPlanesByDir(dir))
  //   return Promise.all(reqs).then((responses)=>{
  //     let result = []
  //     responses.forEach((resp,i)=>{
  //       resp.data.forEach((plane, j)=>{
  //         result.push({
  //           SEQ_REF: (i===0?'long_':'short_')+(plane.Id),
  //           NORMAL_X: plane.Normal[0],
  //           NORMAL_Y: plane.Normal[1],
  //           NORMAL_Z: plane.Normal[2],
  //           ORIGIN_X: plane.Origin[0],
  //           ORIGIN_Y: plane.Origin[1],
  //           ORIGIN_Z: plane.Origin[2],
  //         })
  //       })
  //     })
  //     return result

  //   })
  // },
  // getPlanesByDir(dir){
  //   let url = `static_data/case/videos/${dir}.json`
  //   return cacheTrap(url, url => {
  //     return Api.get(url).then(res => {
  //       return res
  //     })
  //   })
  // }
}
